export const getAuthorInitials = (authorName?: string) => {
  if (!authorName) {
    return '';
  }

  const names = authorName.split(' ');
  return `${names[0].charAt(0).toUpperCase()}${
    names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : ''
  }`;
};
